import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, a = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M7.807 1.082 5.76 3.13a.273.273 0 0 0 .194.466h1.5v3.862H3.59v-1.5a.273.273 0 0 0-.467-.192L1.078 7.81a.273.273 0 0 0 0 .386l2.046 2.047c.173.172.467.05.467-.193v-1.5h3.862v3.862h-1.5a.273.273 0 0 0-.193.467l2.047 2.046c.106.107.28.107.386 0l2.047-2.046a.273.273 0 0 0-.194-.467h-1.5V8.55h3.863v1.5c0 .243.294.365.466.193l2.047-2.047a.273.273 0 0 0 0-.386l-2.047-2.047a.273.273 0 0 0-.466.194v1.5H8.547V3.594h1.5a.273.273 0 0 0 .193-.466L8.193 1.082a.273.273 0 0 0-.386 0Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  a
];
function c(r, d) {
  return e(), t("svg", l, [...n]);
}
const s = { render: c };
export {
  s as default,
  c as render
};
